"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');
global.textFit = require('textfit');

global.md = new MobileDetect(window.navigator.userAgent);
var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

global.isTouch = (('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0));

import slider from './modules/slider';
import artistgrid from './modules/artistgrid';
import macygrid from './modules/macygrid';
import artistpage from './pages/artist';
import showspage from './pages/shows';
import poster from './modules/poster';

$(function(){
  window.prevScroll = 0;
  window.scrollNudgePlus = 0;
  window.scrollNudgeMinus = 0;

  vh();

  $('.poster').each(function(){
    this.poster = new poster(this);
  });

  $('.slider').each(function(){
    this.slider = new slider(this);
  });

  $('.artists-grid').each(function(){
    this.grid = new artistgrid(this);
  });

  $('.page-template-djs, .page-template-artists').each(function(){
    this.macyGrid = new macygrid(this);
  });

  if($('.single-artisti').length>0) {
    new artistpage();
  }

  if($('.page-template-shows').length>0 || $('body.category').length>0) {
    new showspage();
  }

  setTimeout(function(){
    vh();
    $('body').addClass('in');

    $('video').each(function(){
      if(this.paused) {
        $(this).addClass('paused');
      }
    });
  }, 200);

  $(window).on('pageshow', function(){
    $(window).trigger('scroll');
    $('body').removeClass('out').addClass('in');

    if(aNekos.length>0) {
      console.log(aNekos);
      aNekos[0].active = true;
    }
  });

  resize();

  binds();
});


function binds(){
  $(window).on('scroll', function(e){
    if($(window).scrollTop() > 10) {
      if($(window).scrollTop() > window.prevScroll) {
        window.scrollNudgeMinus = 0;
        window.scrollNudgePlus++;
        if(window.scrollNudgePlus > 10) {
          $('#header').addClass('fold');
        }
      } else {
        window.scrollNudgePlus = 0;
        window.scrollNudgeMinus++;
        if(window.scrollNudgeMinus > 10) {
          $('#header').removeClass('fold');
        }
      }
    } else {
      $('#header').removeClass('fold');
    }

    window.prevScroll = $(window).scrollTop();
  });

  $('.menu-button').on('click', function(e){
    e.preventDefault();
    $('#header').toggleClass('in');
  });

  // $(window).scroll(function(){
  //   for(var i=0;i<window.blocks.length;i++) {
  //     var t = window.blocks[i];
  //     var rect = t.getBoundingClientRect();

  //     var inview = rect.top < window.innerHeight*.7 && rect.bottom > 0;

  //     if(inview){
  //       $(t).addClass('in');

  //       if(t.isHero) {
  //         console.log('ishero');
  //         let offsetPrc = Math.min(1, $(window).scrollTop() / window.innerHeight);
  //         let offset = -(100 * offsetPrc);
  //         $(t).css({
  //           'transform' : `translateY(${offset}px)`
  //           // 'transform' : `translate3d(-50%, calc(-50% + ${offset}px), 0)`
  //         });
  //       }
  //     } else {
  //       $(t).removeClass('in');
  //     }

  //     if(window.blocks[i].hasSparkles) {
  //       if(inview && !window.blocks[i].activeSparkles) {
  //         $(window.blocks[i]).find('.sparkles').addClass('in');
  //         window.blocks[i].activeSparkles = true;
  //       } else if(!inview){
  //         $(window.blocks[i]).find('.sparkles').removeClass('in');
  //         window.blocks[i].activeSparkles = false;
  //       }
  //     }
  //   }
  // });
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);
  $('#menuhooks.mobonly').css('top', $('.nav').outerHeight());
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;

  if(window.innerWidth < 787) {
    $('#header .langs').appendTo('#header .menu');
  } else {
    $('#header .langs').appendTo('#header');
  }
}

$(window).on('resize', resize);

/*
function textFits(){
  $('.textfit').each(function(){
      var tar = $(this).parent();

      var h = $(this).parent().outerHeight();
      var w = $(this).parent().outerWidth();

      $(this).css({
        // 'height' : parseInt(h),
        'width' : parseInt(w),
      });

      var t = this;
      setTimeout(function(){
        textFit(
          t,
          {
            multiLine: true,
            minFontSize: 12,
            maxFontSize: remToPx(2.25),
            widthOnly: true,
          }
        );
      },1);
  });
}

window.textFits = textFits;
*/